export * from './Title';
export { BaseSizes as TitleSize } from '../../styles/sizes';